import React from 'react';
import './insightCard.scss';
import {
    BarGraph,
    DropDown
} from '../../commons';


type AppProps = {
    header: string;
    subHeader?: string;
    showDetail?: Boolean;
    showFilter?: Boolean;
    legendName?: string;
    seriesData?: {};
    xAxisData?: {}
    action?: () => void;
    barColor?: [] | any;
    height?: string;
    handleSelectDateRange?: (val: number, type: string) => void;
    xAxisName?: string;
    yAxisName?: string;
    sevenDaysValue?: boolean;
    fifteenDaysValue?: boolean;
    thirtyDaysValue?: boolean;
    cardType?: string;
    oneMonthValue?: boolean;
    threeMonthValue?: boolean;
    sixMonthValue?: boolean;
    oneYearValue?: boolean;
    twoYearsValue?: boolean;
    threeYearsValue?: boolean;
    fourYearsValue?: boolean;
}

const insightCard = ({
    header,
    subHeader,
    showDetail,
    showFilter,
    legendName,
    seriesData,
    xAxisData,
    action,
    barColor,
    height,
    handleSelectDateRange,
    xAxisName,
    yAxisName,
    cardType,
    oneMonthValue,
    threeMonthValue,
    sixMonthValue,
    oneYearValue,
    twoYearsValue,
    threeYearsValue,
    fourYearsValue
}: AppProps) => {
    return (
        <div className="card insightCard">
            <div className="card-body">
                <div className="row d-flex align-items-center mb-3">
                    <div
                        className={(showDetail == true || showFilter == true) ? "col-md-4" : "col-md-12"}
                    >
                        <h4 className="card-title">{header}</h4>
                        <div className="card-subtitle mt-1">{subHeader}</div>
                    </div>
                    {showDetail &&
                        (
                            <div className="col-md-5 text-right">
                                <span className="d-inline-flex text-link" onClick={action}>View More</span>
                            </div>
                        )

                    }
                    {showFilter &&
                        (
                            <div className="col-md-8  text-right">
                                <ul className="filterButtons">
                                    <li className={fourYearsValue ? `selected` : ''} onClick={() => handleSelectDateRange?.(48, cardType || '')}>48 Months</li>
                                    <li className={threeYearsValue ? `selected` : ''} onClick={() => handleSelectDateRange?.(36, cardType || '')}>36 Months</li>
                                    <li className={twoYearsValue ? `selected` : ''} onClick={() => handleSelectDateRange?.(24, cardType || '')}>24 Months</li>
                                    <li className={oneYearValue ? `selected` : ''} onClick={() => handleSelectDateRange?.(12, cardType || '')}>12 Months</li>
                                    <li className={sixMonthValue ? `selected` : ''} onClick={() => handleSelectDateRange?.(6, cardType || '')}>6 Months</li>
                                    <li className={threeMonthValue ? `selected` : ''} onClick={() => handleSelectDateRange?.(3, cardType || '')}>3 Months</li>
                                    <li className={oneMonthValue ? `selected` : ''} onClick={() => handleSelectDateRange?.(1, cardType || '')}>1 Month</li>
                                </ul>
                            </div>
                        )
                    }
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <BarGraph
                            seriesData={seriesData}
                            xAxisData={xAxisData}
                            legendName={legendName}
                            barColor={barColor}
                            height={height}
                            xAxisName={xAxisName}
                            yAxisName={yAxisName}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default insightCard;